import { HR } from "core/interfaces/components/index";
import { ICustomResultDetailProps } from "./ICustomResultDetailProps";
import "./CustomResultDetail.css";
import _ from "lodash";
import { Enhanced } from "utils/ReactUtils";
import CustomTranslation from "components/CustomTranslation/CustomTranslation";

const CustomResultDetail: React.FC<ICustomResultDetailProps> = ({
	ResPrenotazione,
	IsError,
	NomePrestazione,
	DatePrenotazione,
	NomeOperatore,
	EsitoPagamento,
	IdTransazione,
	SaltatoPagamento,t,dataForm
}) => {
	
	let paymentDetails = "";
	let subtitle = "";

	if (IsError) subtitle = t("resultPrenotazione.error.subtitle");
	else if (window.CONFIG.REACT_APP_PAYMENT.ENABLED && !SaltatoPagamento) {
		paymentDetails = t("resultPrenotazione.pagamentoDettagli").replace("<%IDTRANSAZIONE%>", IdTransazione ? IdTransazione! : "TRANSAZIONE MANCANTE");
		subtitle = EsitoPagamento ? t("resultPrenotazione.payment.success.subtitle") : t("resultPrenotazione.payment.warning.subtitle");
	} else subtitle = t("resultPrenotazione.success.subtitle");

	// const getDestinatario = () => {
	// 	var res: string | undefined;
	// 	if (dataForm.destinatarioAssistenza) res = `${dataForm.destinatarioAssistenza.Cognome} ${dataForm.destinatarioAssistenza.Nome} `;

	// 	return res;
	// };

	const getLuogo = () => {
		var resIndirizzo: string | undefined;
		if (dataForm.area && dataForm.area.LuogoErogazione) {
			let luogo = dataForm.area.LuogoErogazione;
			resIndirizzo = `<span> ${luogo.Via ? luogo.Via + (luogo.Civico ? " " + luogo.Civico : "") + "," : ""} </span><span> ${luogo.CAP ?? ""}, ${
				luogo.Comune ?? ""
			} ${luogo.Provincia ? "(" + luogo.Provincia + ")" : ""} </span> `;
		}
		return resIndirizzo;
	};

	return (
		<>
			<div id="customResult">
				<span className={"subtitle"}>{subtitle}</span>

				{!IsError && (
					<>
						<div className={"summary-container"}>
							<div className="text-summary">
								<span className="subtitle">{t("riepilogo.text.destinatarioPrestazione")}</span>
								<span className={"bold-text text"}>{ResPrenotazione?.DestPrestazione}</span>
							</div>
							<HR></HR>
							<div className="text-summary">
								<span className="subtitle">{t("riepilogo.text.dataOraPrenotazione")}</span>
								<span className={"bold-text text"}>
									<CustomTranslation
										t={t}
										type="custom"
										i18Key="data.prenotazione"
										customComponents={{
											br: <br />,
											span: <span className="bold-text text" />,
											nbsp: <>&nbsp;</>,
										}}
										customValues={{ DatePrenotazione: DatePrenotazione ?? "" }}
									/>
								</span>
							</div>
							<HR></HR>
							<div className="text-summary">
								<span className="subtitle">{t("riepilogo.text.prestazione")}</span>
								{_.flatMap(NomePrestazione?.split("<br>"), (value, index) => {
									return (
										<span key={"prest" + index} className={"bold-text text"}>
											{" "}
											{value}
										</span>
									);
								})}
							</div>
							{NomeOperatore && NomeOperatore?.split("<br>").length > 0 && (
								<>
									<HR></HR>
									<div className="text-summary">
										<span className="subtitle">{t("riepilogo.text.operatore")}</span>
										{_.flatMap(NomeOperatore?.split("<br>"), (value, index) => {
											return (
												<span key={"oper" + index} className={"bold-text text"}>
													{" "}
													{value}
												</span>
											);
										})}
									</div>{" "}
								</>
							)}
							{getLuogo() && (
								<>
									<HR></HR>
									<div className="text-summary">
										<span className="subtitle">{t("riepilogo.text.luogo")}</span>
										<span className="text">
											<CustomTranslation
												t={t}
												type="custom"
												i18Key="luogo"
												customComponents={{
													span: <span className="bold-text" />,
												}}
												customValues={{ Luogo: getLuogo() ?? "" }}
											/>
										</span>
									</div>
								</>
							)}
						</div>
						{window.CONFIG.REACT_APP_PAYMENT.ENABLED && !SaltatoPagamento ? (
							EsitoPagamento ? (
								<>
									<span className={"subtitle"}>{t("resultPrenotazione.payment.success.message")}</span>
									<span className={"subtitle"}>{paymentDetails}</span>
								</>
							) : (
								<>
									<span className={"payment-error"}>{t("resultPrenotazione.payment.warning.message")}</span>
									<span className={"subtitle"}>{paymentDetails}</span>
								</>
							)
						) : (
							<></>
						)}
					</>
				)}
			</div>
		</>
	);
};

export default Enhanced( CustomResultDetail,{componentNamespace:"CustomResultDetail"});
